
	import { defineComponent, ref, computed, onMounted, watchEffect,toRefs } from 'vue';
	import { useRoute } from 'vue-router';
	import { getLyraEndpoints, getLyraEndpoint } from '@/core/modules/lyra/services';

	export default defineComponent({
		name: 'template-content-asset',
		props: {
			datum: {
				type: Object,
				required: true,
			},
			carouselIndex: {
				type: Number,
				default: 0
			}
		},
		setup(props) {
			/**
			 * Endpoint
			 */
			const route = useRoute();
			const endpointId = computed((): any => {
				return route.params.endpointId;
			})
			const sectionId = computed((): any => {
				return route.params.sectionId;
			})
			const endpointObj = computed((): any => {
				const sections = getLyraEndpoints('sections');
				const currentSection: any = sections.find((_: any) => _.endpointId === sectionId.value);
				return getLyraEndpoint(endpointId.value, currentSection.endpoints);
			})
			const isCarousel = computed((): boolean => {
				return endpointObj.value ? 'templates' in endpointObj.value && endpointObj.value.templates !== '' : false;
			})

			/**
			 * Asset
			 */
			const assetKey = ref('');
			const { carouselIndex, datum } = toRefs(props)

			watchEffect(() => {
				assetKeysFn();
			})

			onMounted(() => {
                assetKeysFn();
				toggleKeyActive();
            })

			function assetKeysFn () {
				if (isCarousel.value) {
					assetKey.value = `${endpointId.value}.${datum.value.area}.${carouselIndex.value}`;
				} else {
					assetKey.value = `${endpointId.value}.${datum.value.area}`;
				}
			}

			/**
			 * Display asset key
			 */
			const keyActive = ref<boolean>(false);
			const keywordKey = 'k';

			function toggleKeyActive () {
				window.addEventListener('keypress', (e) => {
					if (e.key === keywordKey) {
						keyActive.value = !keyActive.value;
					}
				});
			}

			return { assetKey, endpointId, toggleKeyActive, keyActive }
		}
	})
